import React, {Component} from 'react'
import {observer} from 'mobx-react'

import SpanLink from 'lib/control/SpanLink'
import select_styles from 'lib/control/Select.less'

import InputText from 'lib/struct/form/InputText'
// import SearchableSelect from '../../../control/DependentSearchableSelect'
import SearchableSelect from '../control/DependentSearchableSelect'
import * as ValueSourceType from '../../constant/ValueSourceType'
import {FIXED_COMMA_SEPARATED} from '../../constant/ValueSourceType'

import styles from './OfferFieldValueSourceSelect.less'
import valueSourceOptionsGroupsFactory from "../../class/value_source/ValueSourceOptionsGroupsFactory"
import OfferFieldValueSourceSelectTypePrice from "./OfferFieldValueSourceSelectTypePrice"
// import OfferFieldValueSourceSelectTypeWeight from "./OfferFieldValueSourceSelectTypeWeight"

const {
    'select-wrapper': select_wrapper_class,
} = select_styles

const {
    'value-select-wrapper': value_select_wrapper_class,
    'value-select': value_select_class,

    'specific-value__block': specific_value_block_class,
    'specific-value__cancel-edit-wrapper': specific_value_cancel_class,
} = styles

const SELECT_MODE = {
    SELECT: 'SELECT',
    INPUT_SPECIFIC: 'INPUT_SPECIFIC',
}

@observer export default class OfferFieldValueSourceSelect extends Component {
    constructor(props) {
        super(props)

        const value_source = this.getValueSource()

        this.state = {
            select_mode: this.getIsSpecific(value_source) ? SELECT_MODE.INPUT_SPECIFIC : SELECT_MODE.SELECT,
            selected_option: this.buildSelectedOption(value_source),
        }
    }

    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        if (this.props.fieldObject && this.props.fieldObject.type === "PRICE") {
            return <OfferFieldValueSourceSelectTypePrice
                field={this.props.fieldObject}
                context={context}
            />
        }
        // if (this.props.fieldObject && this.props.fieldObject.type === "WEIGHT") {
        //     return <OfferFieldValueSourceSelectTypeWeight
        //         field={this.props.fieldObject}
        //         context={context}
        //     />
        // }
        const {select_mode, selected_option} = this.state

        const value_source = this.getValueSource()
        if (select_mode === SELECT_MODE.INPUT_SPECIFIC) {
            return (
                <div className={specific_value_block_class} key={this.props.key}>
                    <InputText
                        value={value_source.source_value}
                        onChange={this.onSpecificValueChange}
                        state={context.form_state}
                    />
                    <div className={specific_value_cancel_class}>
                        <SpanLink onClick={this.onSpecificValueReset}>
                            <i className="icon16 close"/>
                        </SpanLink>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={`${select_wrapper_class} ${value_select_wrapper_class}`} key={this.props.key}>
                    <SearchableSelect
                        value={selected_option}
                        defaultOptions={true}
                        loadOptions={this.onValueSourceSearch}
                        onChange={this.onValueSourceChange}

                        className={value_select_class}
                        state={context.form_state}
                        isSearchable={true}
                    />
                </div>
            )
        }
    }

    /**
     * @param {OfferFieldValueSource} value_source
     */
    getIsSpecific = value_source => {
        if (value_source.source_type !== ValueSourceType.SPECIFIC) {
            return false
        }

        const specific_groups = this
            .getValueSourceOptionGroups()
            .filter(g => g.group_source_type === ValueSourceType.SPECIFIC)

        if (specific_groups.length === 0) {
            return false
        }

        if (value_source.source_value === '') {
            return true
        }

        for (const option of specific_groups[0].options) {
            if (
                option.value === value_source.source_value
                || parseInt(option.value) === parseInt(value_source.source_value)
            ) {
                return false
            }
        }

        return true
    }

    /**
     * @param {OfferFieldValueSource} value_source
     */
    buildSelectedOption = (value_source) => {
        for (const group of this.getValueSourceOptionGroups()) {
            if (group.group_source_type === value_source.source_type) {
                if (value_source.isEmpty() || value_source.isDefault()) {
                    return {
                        label: group.group_label,
                        value: value_source.source_type,
                    }
                } else {
                    for (const o of group.options) {
                        if (o.value === value_source.source_value) {
                            return {
                                label: o.label,
                                value: `${value_source.source_type}/${value_source.source_value}`,
                            }
                        }
                    }
                }
            }
        }
        if (value_source.source_type === FIXED_COMMA_SEPARATED) {
            return {
                label: value_source.source_value,
                value: value_source.source_value
            }
        }
        return {
            label: '',
            value: '',
        }
    }

    /**
     * @return {OfferFieldValueSource}
     */
    getValueSource = () => {
        return this.props.value_source
    }

    /**
     * @return {Array<ValueSourceOptionsGroup>}
     */
    getValueSourceOptionGroups = () => {
        /** @type {String|null} */
        const field = this.props.field

        return valueSourceOptionsGroupsFactory.getForDataset(field)
    }

    onSpecificValueChange = (event) => {
        const value_source = this.getValueSource()

        const {onChange} = this.props

        value_source.source_value = event.target.value
        if (onChange) {
            onChange(value_source)
        }
    }

    onSpecificValueReset = () => {
        const value_source = this.getValueSource()

        value_source.source_type = ValueSourceType.IS_EMPTY
        value_source.source_value = ''

        this.setState({
            select_mode: SELECT_MODE.SELECT,
            selected_option: {
                label: '',
                value: ValueSourceType.IS_EMPTY,
            },
        })
    }

    onValueSourceChange = option => {
        const {onChange} = this.props

        const value_source = this.getValueSource()

        const value_source_new = this.getValueSourceFromString(option.value)
        if (value_source_new.source_type === FIXED_COMMA_SEPARATED) {
            option = this.getOptionForCommaSeparatedAndUpdateValueSource(value_source, value_source_new)
        } else {
            value_source.source_value = value_source_new.source_value
            value_source.source_type = value_source_new.source_type
        }

        this.setState({
            select_mode: this.getIsSpecific(value_source) ? SELECT_MODE.INPUT_SPECIFIC : SELECT_MODE.SELECT,
            selected_option: option,
        })

        if (onChange) {
            onChange(value_source)
        }
    }

    getValueSourceFromString(string) {
        const value_parts = string.split('/')
        const value_source = {}
        if (value_parts.length === 1) {
            value_source.source_type = value_parts[0]
            value_source.source_value = ''
        } else if (value_parts.length === 2) {
            value_source.source_type = value_parts[0]
            value_source.source_value = value_parts[1]
        }
        return value_source
    }

    getOptionForCommaSeparatedAndUpdateValueSource (value_source, value_source_new) {
        const option = {}
        if (value_source.source_type === FIXED_COMMA_SEPARATED) {
            const parts = value_source.source_value.split(',')
            if (parts.length > 1) {
                let newValueSource = []
                let deleteValue = false
                for (const part of parts) {
                    if (part === value_source_new.source_value) {
                        deleteValue = true
                        continue
                    }
                    newValueSource.push(part)
                }
                if (deleteValue && newValueSource.length > 0) {
                    value_source.source_value = newValueSource.join(',')
                    option.label = value_source.source_value
                } else  {
                    option.label = value_source.source_value + ',' + value_source_new.source_value
                    value_source.source_value = option.label
                }
            } else {
                if (value_source.source_value !== value_source_new.source_value) {
                    option.label = value_source.source_value + ',' + value_source_new.source_value
                    value_source.source_value = option.label
                } else {
                    value_source.source_value = value_source_new.source_value
                    value_source.source_type = value_source_new.source_type
                    option.label = value_source.source_value
                }
            }
        } else {
            value_source.source_value = value_source_new.source_value
            value_source.source_type = value_source_new.source_type
            option.label = value_source.source_value
        }

        return option;
    }
    onValueSourceSearch = (search) => {
        /** @type {SettingsContext} */
        const context = this.props.context
        const field = this.props.field

        return context.lazyGetValueSourceOptions(field, search, this.props.value_source)
    }
}